//
// Frontend mirror of backend/app/routes/accounts.py's
// _AGENT_CUSTOMER_FIELD_RULES table. Must be kept in sync manually — this
// repo has no shared client/server schema generation. If a field's gating
// changes on the backend, update this file in the same change.

export const AGENT_CUSTOMER_FIELD_RULES = {
  name:                      { perm: 'can_update_info' },
  username:                  { perm: 'can_update_info' },
  new_password:              { perm: 'can_update_info' },
  is_read_only:              { perm: 'can_suspend_wagering' },
  is_active:                 { perm: 'can_deactivate_account' },
  free_play_adjustment:      { perm: 'can_adjust_free_play_balance' },
  balance_adjustment:        { perm: 'can_change_settle_figure' },
  casino_access:             { perm: 'can_allow_deny_casino' },
  weekly_limit:              { perm: 'can_change_credit_limit', min: 'credit_limit_min', max: 'credit_limit_max' },
  free_play_loss_percentage: { perm: 'can_change_free_play_limit', min: 'free_play_limit_min', max: 'free_play_limit_max' },
  min_bet:                   { perm: 'can_change_wager_limit', min: 'wager_limit_min' },
  max_bet:                   { perm: 'can_change_wager_limit', max: 'wager_limit_max' },
  live_min_bet:              { perm: 'can_change_live_wager_limit', min: 'live_wager_limit_min' },
  live_max_bet:              { perm: 'can_change_live_wager_limit', max: 'live_wager_limit_max' },
  parlay_min_bet:            { perm: 'can_change_parlay_limit', min: 'parlay_limit_min' },
  parlay_max_bet:            { perm: 'can_change_parlay_limit', max: 'parlay_limit_max' },
  game_limit:                { perm: 'can_change_contest_limit', min: 'contest_limit_min', max: 'contest_limit_max' },
  casino_min_bet:            { perm: 'can_change_casino_limit', min: 'casino_limit_min' },
  casino_max_bet:            { perm: 'can_change_casino_limit', max: 'casino_limit_max' },
  casino_weekly_max_win:     { perm: 'can_change_casino_weekly_limit', min: 'casino_weekly_limit_min', max: 'casino_weekly_limit_max' },
  casino_weekly_max_loss:    { perm: 'can_change_casino_weekly_limit', min: 'casino_weekly_limit_min', max: 'casino_weekly_limit_max' },
  cashout_disabled_for_customer: { perm: 'can_access_settings' },
};

export function isFieldVisible(field, perms) {
  const rule = AGENT_CUSTOMER_FIELD_RULES[field];
  if (!rule || !perms) return false;
  return !!perms[rule.perm];
}

export function getFieldRange(field, perms) {
  const rule = AGENT_CUSTOMER_FIELD_RULES[field];
  if (!rule || (!rule.min && !rule.max)) return null;
  return {
    min: rule.min ? perms[rule.min] : undefined,
    max: rule.max ? perms[rule.max] : undefined,
  };
}
